import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Pagination } from '../models/pagination';
import { ApiResponse } from '../models/api-response';
import { ApiError } from '../models/api-error';
import { ErrorNotificationService } from './error-notification.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  baseAPIUrl: string = environment.baseAPIUrl;

  constructor(
    private http: HttpClient,
    private errorNotification: ErrorNotificationService
  ) { }

  getAPIUrl(endpoint: string) {
    return `${this.baseAPIUrl}/${endpoint}`;
  }

  public getAll<T>(endpoint: string, options?: { params?: { [param: string]: string | string[]; } }) {
    return this.http.request<T>('get', this.getAPIUrl(endpoint), options)
      .pipe(map(unit => <ApiResponse<T>>{ code: 0, message: null, errors: null, payload: <T>this.generatePagination(unit) }),
      catchError(error => this.handleError(error)));
  }

  public get<T>(endpoint: string, headers?: HttpHeaders): Observable<ApiResponse<T>> {
    return this.http.get<T>(this.getAPIUrl(endpoint), { headers: headers })
      .pipe(map(unit => <ApiResponse<T>>{ code: 0, message: null, errors: null, payload: <T>unit }),
      catchError(error => this.handleError(error)));
  }

  public add<T>(endpoint: string, item?: any, headers?: HttpHeaders): Observable<ApiResponse<T>> {
    return this.http.post<T>(this.getAPIUrl(endpoint), item, { headers: headers })
      .pipe(map(unit => <ApiResponse<T>>{ code: 0, message: null, errors: null, payload: <T>unit }),
      catchError(error => this.handleError(error)));
  }

  public update<T>(endpoint: string, item: any, headers?: HttpHeaders): Observable<ApiResponse<T>> {
    return this.http.put<T>(this.getAPIUrl(endpoint), item, { headers: headers })
      .pipe(map(unit => <ApiResponse<T>>{ code: 0, message: null, errors: null, payload: <T>unit }),
      catchError(error => this.handleError(error)));
  }

  public delete<T>(endpoint: string, headers?: HttpHeaders): Observable<ApiResponse<T>> {
    return this.http.delete<T>(this.getAPIUrl(endpoint), { headers: headers })
      .pipe(map(unit => <ApiResponse<T>>{ code: 0, message: null, errors: null, payload: <T>unit }),
      catchError(error => this.handleError(error)));
  }

  private generatePagination(payload: any) {
    payload.pagination = <Pagination>{
      elementsPerPage: payload.elementsPerPage,
      page: payload.currentPage,
      totalElements: payload.totalElements,
      totalPages: payload.totalPages
    };
    return payload;
  }

  private handleError(res: HttpErrorResponse | any) {
    let error = <ApiError>{
      code: !!res.error && !!res.error.code ? res.error.code : res.status,
      message: !!res.error && !!res.error.message ? res.error.message : res.statusText,
      errors: !!res.error && !!res.error.errors ? res.error.errors : [] };
    this.errorNotification.notifyError(error);
    console.log('Request returned with error', res.error, res);
    return throwError(error);
  }

}
